<template>
  <div class="progress-status text-28">{{ percent }}%</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProgressStatus',
  props: {
    percent: {
      type: Number,
      default: 0,
    },
  },
})
</script>

<style lang="scss" scoped>
.progress-status {
  width: 5.52rem;
  height: 2.3125rem;
  line-height: 1;
  position: relative;
  background-image: linear-gradient(to right, #c31818, #c31818, #c31818);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1.25rem;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: -0.5rem;
    top: 0;
    bottom: 0;
    width: 0.3125rem;
    height: 2.3125rem;
    background-color: #ff1717;
  }
}
</style>
